import { render, staticRenderFns } from "./userAccessMgmtEdit.vue?vue&type=template&id=0062c58c&"
import script from "./userAccessMgmtEdit.vue?vue&type=script&lang=js&"
export * from "./userAccessMgmtEdit.vue?vue&type=script&lang=js&"
import style0 from "./userAccessMgmtEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports